import store from '../store/store'

export const checkVideoSelected = (to, from, next) => {
  if (!to.params.course_id) {
    return next()
  }

  if (!store.getters.getContent) {
    return next()
  }

  if (store.getters.getContent.course && store.getters.getContent.course !== to.params.course_id) {
    store.dispatch('deleteContent')
  }

  if (store.getters.getContent.module && store.getters.getContent.module.course && store.getters.getContent.module.course !== to.params.course_id) {
    store.dispatch('deleteContent')
  }

  return next()
}
